module.exports = __webpack_public_path__ + "static/media/locationTec-stamp.0b457b07.png";